export enum API_REQUEST_STATE {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCEEDED_ADD = 'succeededAdd',
  SUCCEEDED_EDIT = 'succeededEdit',
  SUCCEEDED_DELETE = 'succeededDelete',
  SUCCEEDED_GET = 'succeededGet',
  FAILED = 'failed',
  FAILED_DELETE_ARTICLE = 'failedDelete',
  FAILED_DELETE_SUBCATEGORY = 'failedDeleteCategory',
}
